import { NgClass } from '@angular/common';
import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { SyncType } from '@rocksoft/apple-sync-sdk';

@Component({
  selector: 'era-device-sync-status-retry-ui',
  templateUrl: './device-sync-status-retry.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgClass, FaIconComponent],
})
export class DeviceSyncStatusRetryComponent {
  readonly syncType = input.required<SyncType>();
  readonly allowRetry = input(false);

  public readonly scheduleTaskEvent = output<SyncType>();

  public retrySync() {
    this.scheduleTaskEvent.emit(this.syncType());
  }
}
